export default __webpack_public_path__ + "static/media/plus.f8ff49fc.svg";